import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { Layout } from './containers/Layout';
import paths from './paths';
import AuthProvider from './auth/AuthProvider';
import 'cropperjs/dist/cropper.min.css';
import Error403 from './containers/403/Error403';

const authUrl = `${process.env.REACT_APP_BACKEND_HOST}/${process.env.REACT_APP_VERIFY_AUTH_URL}`;

class App extends Component {
  displayName = App.name;

  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route
            path={paths.advocates.forbidden}
            exact
            name="403"
            component={Error403}
          />
          <AuthProvider authUrl={authUrl}>
            <Route component={Layout} />
          </AuthProvider>
        </Switch>
      </BrowserRouter>
    );
  }
}

export default hot(module)(App);
